function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 8191.52,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M82697 31476l22339 22339m-59572 59572l-26061 3729 3719 -26069 67022 -67022c6169,-6169 16170,-6169 22339,0 6169,6169 6169,16173 0,22341l-67020 67020z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 136517 136517",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pencil.8feb5e3f.svg";
export { SvgComponent as ReactComponent };